import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { ConfigContext } from "../../../context/ConfigContext";

const ErrorPageWithoutThemes = ({
  title,
  subtitles,
  showHomeButton,
  showLoginButton,
}: {
  title: string;
  subtitles: string[];
  showHomeButton?: boolean;
  showLoginButton?: boolean;
}) => {
  const { JDPO_JAVA_URL } = useContext(ConfigContext);
  const { t, ready } = useTranslation("common", { useSuspense: false });
  if (!ready) {
    return <></>;
  }
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "10vh",
      }}
      data-testid="error-page"
    >
      <WarningAmberIcon
        data-testid="error-icon"
        color="warning"
        fontSize="large"
      />
      <Typography
        sx={{
          textAlign: "center",
          paddingTop: "1.5rem",
          paddingBottom: "0.75rem",
          fontWeight: "600",
        }}
        data-testid="error-title"
        component="h2"
      >
        {t(title)}
      </Typography>
      <Box data-testid="error-subtitles">
        {subtitles.map((content, idx) => (
          <Typography sx={{ textAlign: "center" }} key={`subtitle-${idx + 1}`}>
            {t(content)}
          </Typography>
        ))}
      </Box>
      {showHomeButton && (
        <Link
          data-testid="home-button"
          style={{
            marginTop: "1.5rem",
            color: "#1b1b1b",
            fontWeight: "600",
            textDecoration: "none",
          }}
          to={`${JDPO_JAVA_URL}/dns/loadMain.con`}
        >
          {t("authentication.failed.returnHome")}
        </Link>
      )}
      {showLoginButton && (
        <Link
          data-testid="login-button"
          style={{
            textDecoration: "none",
            marginTop: "1.5rem",
            color: "#1b1b1b",
          }}
          to={`${JDPO_JAVA_URL}/dns/loadMain.con`}
        >
          {t("authentication.failed.login")}
        </Link>
      )}
    </Box>
  );
};

export default ErrorPageWithoutThemes;
